<template>
  <div class="layout-main">
    <div class="openai-main">
      <div class="openai-main-wrapper">
        <div v-for="ai in openaiData" :key="ai" class="openai-main-stream">
          <div class="index_question-container">
            <div class="top-query-margin">
              {{ ai.question }}
            </div>
          </div>
          <div class="index_answer-container">
            <div class="openai-logo" style="position: absolute; top: -2px; left: 0">
              <img
                src="https://gips2.baidu.com/it/u=1024110589,3770674247&fm=3028&app=3028&f=PNG&fmt=auto&q=75&size=f48_37">
            </div>
            <div class="openai-search-answer-generate">
              <i style="font-size: 30px;" v-if="ai.answer === 'loading'" class="el-icon-loading"></i>
              <template v-else>
                <p v-html="ai.answer">
                </p>
              </template>
            </div>
          </div>
        </div>
        <div class="openai-bottom-wrapper">
          <div class="openai-wrap">
            <div class="openai-bottom">
              <div class="input-wrap">
                <div class="input-container">
                  <div class="openai-input-box">
                    <textarea class="openai-input" v-model="question" placeholder="给 DeepSeek 发送消息 "
                      rows="2"></textarea>
                    <div class="openai-div"></div>
                  </div>
                  <div class="cs-input-function-wrapper">
                    <div style="
                        flex: 1;
                        justify-content: flex-end;
                        align-items: center;
                        display: flex;
                      ">
                      <el-button type="primary" icon="el-icon-top" @click="handleOpenAI" circle
                        :disabled="question === ''" :loading="loading"></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="
              font-size: 12px;
              color: #a3a3a3;
              margin: 6px 0;
              line-height: 14px;
            ">
            内容由 AI 生成，请仔细甄别
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import OpenAI from 'openai'
import { openaiService } from "@/api/openai";
export default {
  name: "OpenAI",
  components: {},
  data() {
    return {
      loading: false,
      question: "",
      openaiData: []
    };
  },
  methods: {
    // async getOpenAi(question) {
    //   if (question) {
    //     const openai = new OpenAI(
    //       {
    //         apiKey: process.env.DASHSCOPE_API_KEY,
    //         baseURL: "https://dashscope.aliyuncs.com/compatible-mode/v1"
    //       }
    //     );
    //     const completion = await openai.chat.completions.create({
    //       model: "deepseek-r1",
    //       messages: [
    //         { role: "user", content: question }
    //       ],
    //     });

    //     console.log(completion.choices[0].message.content);
    //   }
    // },
    async handleOpenAI() {
      const question = this.question
      if (question) {

        this.loading = true
        this.openaiData.push({
          question: question,
          answer: 'loading'
        })
        // 调用deepseek
        const res = await openaiService.getOpenAI({
          model: "deepseek-r1",
          messages: [
            { role: "user", content: question }
          ],
        })
        this.loading = false
        this.question = ''
        this.openaiData[this.openaiData.length -1].answer = res.data.choices[0].message.content.replace(/\n/g, '<br>')
      }

    }
  }

};
</script>

<style scoped>
.layout-main {
  width: 100%;
  /* height: 100%; */
  height: calc(-60px + 100vh);
  display: flex;
  position: relative;
}

.openai-main {
  padding: 0 32px;
  min-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

.openai-main-wrapper {
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  display: flex;
  position: relative;
}

.openai-main-stream {
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  flex-grow: 1;
  margin: auto;
  padding: 38px 0 40px;
}

.index_question-container {
  justify-content: flex-end;
  margin-bottom: 16px;
  padding-bottom: 32px;
  display: flex;
}

.top-query-margin {
  font-size: 16px;
  line-height: 28px;
  color: #262626;
  padding: calc((44px - 28px) / 2) 20px;
  box-sizing: border-box;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: #eff6ff;
  border-radius: 14px;
  max-width: calc(100% - 48px);
  position: relative;
}

.index_answer-container {
  font-size: 14px;
  color: rgb(64 64 64);
  margin-bottom: 12px;
  padding-left: 48px;
  position: relative;
}

.openai-logo {
  background-color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  display: flex;
  /* box-shadow: 0 0 0 1px #d5e4ff; */
}

.openai-search-answer-generate {
  --ds-md-zoom: 1.143;
  --ds-md-font-size: calc(1.143 * 14px);
  --ds-md-line-height: calc(1.143 * 25px);
  font-size: calc(1.143 * 14px);
  min-height: calc(1.143 * 14px);
  line-height: calc(1.143 * 25px);
}

.openai-bottom-wrapper {
  background-color: #fff;
  z-index: 1;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  display: flex;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
}

.openai-wrap {
  /* transform: translateY(-7.5vh); */
  max-width: 800px;
  flex-grow: 1;
  width: 100%;
  position: relative;
}

.openai-bottom {
  --padding: 14px;
  cursor: text;
  box-sizing: border-box;
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  background-color: transparent;
  background-color: #fff;
  border-radius: 24px;
  flex-direction: column;
  display: flex;
  position: relative;
}

.input-container {
  z-index: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px;
  display: flex;
  overflow: hidden;

  background-color: #f3f4f6;
  box-shadow: 0px 0px 0px 0.5px #dce0e9;
  border-radius: 24px;
}

.openai-input-box {
  width: 100%;
  max-height: calc(12 * 28px);
  margin: 0 4px;
  position: relative;
}

.openai-input:focus-visible {
  border: none;
  /* 移除边框 */
  outline: none;
  /* 移除默认的蓝色轮廓 */
}

.cs-input-function-wrapper {
  --function-row-offset: 2px;
  width: calc(100% - 2px);
  padding-left: 2px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 4px;
  display: flex;
}

.openai-input {
  resize: none;
  color: #404040;
  caret-color: #404040;
  background-color: transparent;
  position: absolute;

  font-size: inherit;
  line-height: inherit;
  word-break: break-word;
  white-space: pre-wrap;
  border: none;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: inherit;
  display: block;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

.openai-div {
  visibility: hidden;
  pointer-events: none;
  min-height: 56px;

  font-size: inherit;
  line-height: inherit;
  word-break: break-word;
  white-space: pre-wrap;
  border: none;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: inherit;
  display: block;
  overflow: auto;
}
</style>
